import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import CustomAppBar from "../../components/CustomAppBar/CustomAppBar";
import SecureComponent from "../../components/SecApp/SecureComponent";
import { useConfig } from "../../contexts/ConfigContext";
import AccessLogReport from "../../components/AccessLogReport/AccessLogReport";

function AccessLogReportPage({ allowedRoles }) {
  const { config } = useConfig();
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <>
      <SecureComponent allowedRoles={allowedRoles}>
        <div className={theme} data-testid="theme-name">
          <CustomAppBar className="app-bar " config={config} />
          <div data-testid="access-log-page">
            <AccessLogReport config={config} />
          </div>
        </div>
      </SecureComponent>
    </>
  );
}
AccessLogReportPage.propTypes = {
  config: PropTypes.object,
  allowedRoles: PropTypes.array,
};
export default AccessLogReportPage;
